import http from "./http";
import Service from "../Service";


/**
 * @type BuyerService
 */
export default class BuyerService extends Service {

    delete(id){
        return http.delete(`clients/buyers/${id}`, {
            headers: this.getHeaders()
        })
    }

    // Desativa (false) ou reativa (true) um comprador do proprio cliente.
    updateStatus(id, active){
        return http.put(`clients/buyers/${id}/status`, { active }, {
            headers: this.getHeaders()
        })
    }
}
